import Http from 'services/Http';
import computeContentMd5Base64 from 'utils/computeContentMd5Base64';
import parseFileName from 'utils/getFileExtension';

class App {
  async find(id) {
    const { data } = await Http.get(`/v1/app/${id}`);
    return data.app;
  }

  async list(page = 0, perPage = 100) {
    const { data } = await Http.get(`/v1/app?page=${page}&perPage=${perPage}`);
    return data;
  }

  async create(form) {
    const response = await Http.post('/v1/app', form);
    return response.data.app;
  }

  async update(id, form) {
    const response = await Http.patch(`/v1/app/${id}`, form);
    return response.data.app;
  }

  async install(id, installed) {
    const { data } = await Http.patch(`/v1/app/${id}/${installed ? '' : 'un'}install`);
    return data;
  }

  async addEmployee(id) {
    const { data } = await Http.post(`/v1/app/${id}/employee`);
    return data;
  }

  async removeEmployee(id) {
    const { data } = await Http.delete(`/v1/app/${id}/employee`);
    return data;
  }

  async regenerateSecret(id, name) {
    const { data } = await Http.patch(`/v1/app/${id}/regenerate/${name}`);
    return data;
  }

  async destroy(id) {
    const { data } = await Http.delete(`/v1/app/${id}`);
    return data;
  }

  async upload(id, field, avatar) {
    if (field !== 'avatar') {
      const form = new FormData();
      form.append(field, avatar);
      const { data } = await Http.post(`/v1/app/${id}/file`, form);
      return data.app;
    }
    const { type: mimeType, name } = avatar;
    const { ext } = parseFileName(name);
    const contentMd5 = await computeContentMd5Base64(avatar);
    try {
      const { data } = await Http.post(`/v1/app/${id}/avatar/sign-url`, {
        mimeType,
        ext,
        contentMd5,
      });
      await Http.putS3(data.url || data.uploadUrl, avatar, {
        headers: { 'Content-Type': mimeType, 'Content-MD5': contentMd5, ...(data.headers || {}) },
        timeout: 0,
      });
      const uploaded = await Http.patch(`/v1/app/${id}/avatar/uploaded`, { id: data.id });
      return uploaded.data.app;
    } catch (err) {
      if (err.status === 409) {
        const form = new FormData();
        form.append(field, avatar);
        const { data } = await Http.post(`/v1/app/${id}/file`, form);
        return data.app;
      }
      throw err;
    }
  }

  async getGroups(id) {
    const { data } = await Http.get(`/v1/app/${id}/groups`);
    return data;
  }
}

export default new App();
